import { defaultThemeFontsNewDesign } from './Fonts';

const defaultThemeNewDesignColors = {
  white: '#FFFFFF',
  black: '#000000',
  darkText: '#28272F',
  mutedText: '#6F6F8F',
  strongWhite: '#F7F0F0',
  blueberry: '#ACB1FF',
  darkerBlueberry: '#7c84f6',
  semiLightBlueberry: 'rgba(172, 177, 255, 0.5)',
  lightBlueberry: 'rgba(172, 177, 255, 0.25)',
  lightPurple: '#e0e1ff',
  darkBlue: '#2A3547',
  wheat: '#F2E8E1',
  peach: '#FF9F9B',
  toasted: '#BB9F57',
  dough: '#E6CC98',
  lightGreen: '#24cd73',
  green: '#20b865',
  semiLightGreen: '#24cd7335',
  marmelade: '#F85E1D',
  darkerMarmelade: '#dc4400',
  darkRed: '#BD2B2B',
  burntOrange: '#F17743',
  lightShadeOfBrown: '#E6CC98',
  transparent: 'transparent',
  shadow: 'rgba(0, 0, 0, 0.3)',
  lightGray: '#F0F0F0',
  gray: '#BCBCBC',
  softAmber: '#FEF3C7',
  mediumGray: '#8A8A8A',
  darkGray: '#494949',
  scrollTopIcon: 'rgba(0,0,0,0.4)',
};

const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#155c7e',
      light: '#ECF2FF',
      dark: '#4570EA',
    },
    secondary: {
      main: '#49BEFF',
      light: '#E8F7FF',
      dark: '#23afdb',
    },
    success: {
      main: '#13DEB9',
      light: '#E6FFFA',
      dark: '#02b3a9',
      contrastText: '#ffffff',
    },
    info: {
      main: '#539BFF',
      light: '#EBF3FE',
      dark: '#1682d4',
      contrastText: '#ffffff',
    },
    error: {
      main: '#FA896B',
      light: '#FDEDE8',
      dark: '#f3704d',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFAE1F',
      light: '#FEF5E5',
      dark: '#ae8e59',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#F2F6FA',
      200: '#EAEFF4',
      300: '#DFE5EF',
      400: '#7C8FAC',
      500: '#5A6A85',
      600: '#2A3547',
    },
    text: {
      primary: '#28272F',
      secondary: '#2A3547',
    },
    divider: '#e5eaef',
    background: {
      default: '#ffffff',
    },
  },
  custom: {
    font: defaultThemeFontsNewDesign,
    color: defaultThemeNewDesignColors,
  },
};

export { baselightTheme, defaultThemeNewDesignColors };
